/**
 * Dashboard Types and Interfaces
 *
 * This file contains all TypeScript interfaces and types for the Dashboard component.
 * Designed to be scalable for future backend integration.
 */

// Base metric interface - foundation for all metric types
export interface BaseMetric {
    title: string;
    value: string;
}

// Sales metrics with pricing information
export interface SalesMetric extends BaseMetric {
    change: string;
    avgPrice: string;
}

// Bookings/Clients/Staff metrics with optional per-day information
export interface BookingsMetric extends BaseMetric {
    change: string;
    perDay?: string;
}

// Union type for all possible metric data structures
export type MetricData = SalesMetric | BookingsMetric | BaseMetric;

// Dashboard tab types
export type DashboardTab = 'sales' | 'bookings' | 'clients' | 'staff';

// Filter dropdown interfaces
export interface FilterOption {
    id: string;
    name: string;
}

export interface DropdownState {
    year: boolean;
    comparison: boolean;
    businessType: boolean;
    region: boolean;
    location: boolean;
}

// Type guards for runtime type checking
export const isSalesMetric = (metric: MetricData): metric is SalesMetric => {
    return 'change' in metric && 'avgPrice' in metric;
};

export const isBookingsMetric = (metric: MetricData): metric is BookingsMetric => {
    return 'change' in metric && !('avgPrice' in metric);
};
